export enum QuerySortEnum {
  LATEST = 'latest',
  OLDEST = 'oldest',
  A2Z = 'a-z',
  Z2A = 'z-a',
}
